;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"

type SvgComponent = React.FunctionComponent<React.SVGProps<SVGSVGElement>>

/**
 * Lightweight replacement for @mui/material/SvgIcon. Renders an svgr-imported SVG
 * and colors it the way MUI's SvgIcon did: the root gets `fill: currentColor`, so
 * paths without an explicit fill inherit the CSS `color`. Keeps these icons off
 * MUI/Emotion (they render above the fold on the home page).
 */
export default function SvgAsset({
  svg: Svg,
  viewBox,
  width,
  height,
  color,
}: {
  svg: SvgComponent
  viewBox: string
  width: string
  height: string
  color: string
}) {
  return (
    <Svg viewBox={viewBox} style={{ width, height, color, fill: "currentColor" }} />
  )
}
